import Lottie from "react-lottie";
import minesLottie from "../../lotties/mine.json";
import mouseLottie from "../../lotties/mouse_lottie.json";
import "./style/style.css";

export function Logo() {
  const mouseAnimationOption = {
    loop: true,
    autoplay: true,
    animationData: mouseLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const mineAnimationOption = {
    loop: true,
    autoplay: true,
    animationData: minesLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="logo_section" id="home">
      <img alt="mines" src="/img/bg.jpg" className="background" />
      <div className="shadow" />
      <section className="logo_container">
        <div className="logo">
          <img src="/img/logo.png" alt="" />
        </div>

        <div className="header_container">
          <div className="mine_lottie">
            <Lottie options={mineAnimationOption} />
          </div>
          <p className="info">Discover the next phenomenon in iGaming!</p>
        </div>

        <div className="mouse_lottie">
          <Lottie
            options={mouseAnimationOption}
            height={"75px"}
            width={"75px"}
          />
        </div>
      </section>
    </section>
  );
}
